import React from 'react';
import Card from '../../common/Skeleton/Card';
import parentStyle from '../index.scss';
import style from './index.scss';

export const Tabs = () => (
    <div className={style.tabsContainer}>
        <div className={style.tabs}>
            <div className={style.tab} />
            <div className={style.tab} />
            <div className={style.tab} />
        </div>
    </div>
);

export default () => (
    <div className={parentStyle.container}>
        <div className={parentStyle.fixedContainer}>
            <Tabs />
            <div className={parentStyle.raceList}>
                <Card />
                <Card />
                <Card />
            </div>
        </div>
    </div>
);
